import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import sessionStoreUtil from "../ApiSetup/Localstorage";


export const ProtectedRoutes = () => {

    const auth_token = sessionStoreUtil.getLSItem('auth_token')
    const navigate = useNavigate()
    const isAuth = auth_token ? true : false;

    useEffect(() => {
        if (!isAuth) {
            navigate("/login")
        }
    }, [isAuth, navigate])

    return isAuth ? <Outlet /> : null;
};
